import { BaseDto } from './base.dto';
import { OrderServiceTypeDto } from './orderServiceType.dto';
import { RecipeDto } from './recipe.dto';
import { StockDto } from './stock.dto';
import { StockUnitDto } from './stockUnit.dto';

export class RecipeDetailDto extends BaseDto {
  recipe: RecipeDto;
  stock? : StockDto;
  bulkRecipe? : RecipeDto;
  stockUnit: StockUnitDto;
  amount: number;
  orderServiceTypeId?:number;
  orderServiceType: OrderServiceTypeDto;
  effectiveDate?: string;
  recipeId?: number;
  stockId?: number;
  bulkRecipeId?: number;
  stockUnitId?: number;


  constructor(
    recipe: RecipeDto,
    stock: StockDto,
    bulkRecipe: RecipeDto,
    stockUnit: StockUnitDto,
    amount: number,
    orderServiceTypeId:number,
    effectiveDate?: string,
    recipeId?: number,
    stockId?: number,
    bulkRecipeId?: number,
    stockUnitId?: number,
  ) {
    super();
    this.recipe = recipe;
    this.stock = stock;
    this.bulkRecipe = bulkRecipe;
    this.stockUnit = stockUnit;
    this.amount = amount;
    this.orderServiceTypeId = orderServiceTypeId;
    this.effectiveDate = effectiveDate;
    if (recipeId) {
      this.recipeId = recipeId
    }
    if (stockId) {
      this.stockId = stockId
    }
    if (bulkRecipeId) {
      this.bulkRecipeId = bulkRecipeId
    }
    if (stockUnitId) {
      this.stockUnitId = stockUnitId
    }
  }

}
